/**
 * ElasticForm constructor.
 * Manages creation, destruction and state of form
 */

let _config;

class ElasticForm extends ElasticInterface {
    /** @returns {string} */
    static get STATE_FIRST () { return 'first'; }
    /** @returns {string} */
    static get STATE_PROGRESSION () { return 'progression'; }
    /** @returns {string} */
    static get STATE_LAST () { return 'last'; }

    static get config() { return _config; }
    static set config(cfn){ _config = cfn; }

    /** @returns {number} */
    get length () { return this.screens.length; }
    /** @returns {ElasticScreen} */
    get screen () { return this.screens[this.index]; }

    /**
     *
     * @param form {Object} Form data from API
     * @param config {Object} External configuration
     * @param current_business {Number|null} Current business`s id
     * @param selector {string} jQuery selector
     */
    constructor (form, config, current_business = null, selector = '#elastic-modal') {
        super();
        this.assignObjKeys(form);
        _config = config;
        this.screens = this.screens.map((screen) => { return new ElasticScreen(screen); });
        this.modal = $(selector);
        this.reply_endpoint = config.reply_endpoint;
        this.current_business = current_business;
        this.show_continue_button_at_end = form['show_continue_button'];
        this.show_top_cities = form['show_top_cities'];
        this.raw_screens = form['screens'];
    }

    /**
     * Initialize events on ElasticForm DOM elements,
     * and sets initial values
     */
    init () {
        this.index = 0;
        this.progress = 0;
        this.state = ElasticForm.STATE_FIRST;

        this.dispatch();

        this.modal.on('click', '.elastic-step', (event) => {
            let btn = $(event.currentTarget);

            if (btn.data('step') > 0 && this.state == ElasticForm.STATE_LAST) {
                this.submit();
            } else {
                if (btn.data('step') > 0) {
                    this.next();
                }

                if (btn.data('step') < 0) {
                    this.prev();
                }
            }
            event.stopImmediatePropagation();
            return false;
        });

        this.modal.on('submit', '#elastic-form', (event) => {
            event.preventDefault();

            console.log('on submit elastic-form')
            this.modal.find('.elastic-button-next').click();

            event.stopImmediatePropagation();
            return false;
        });
        // this needs some refactoring, as each Field should have different
        // custom answer handler
        this.modal.on('click check', '.custom_answers input.allow_custom', (event) => {
            let allow = $(event.currentTarget);

            allow.closest('.elastic-answer')
                 .find('.available_answers')
                 .find('input[type="radio"]').prop('checked', false);
        });

        this.modal.on('click check', '.available_answers input[type="radio"]', (event) => {
            let radio = $(event.currentTarget);

            radio.closest('.elastic-answer')
                 .find('.custom_answers')
                 .find('input[type="radio"]').prop('checked', false).end()
                 .find('input[type="text"]').val('');
        });

        this.modal.on('click focus', 'input[name="custom_answer"]', (event) => {
            let input = $(event.currentTarget);

            input.closest('.custom_answers')
                 .find('input.allow_custom').trigger('click').prop('checked', true).end();
        });
    }

    /**
     * Counts progress for progressbarr
     */
    countProgress () {
        let pcFactor = 100;

        this.progress = parseInt((this.index + 1) / this.length * pcFactor);
    }

    /**
     * Checks where user actually is and set proper state
     */
    refreshState () {
        if (this.index == 0) {
            this.state = ElasticForm.STATE_FIRST;
        }

        if (this.index > 0 && this.index < this.length - 1) {
            this.state = ElasticForm.STATE_PROGRESSION;
        }

        if (this.index >= this.length -1) {
            this.state = ElasticForm.STATE_LAST;
        }
    }

    /**
     * Manages state, render step and button visibility
     */
    dispatch () {
        this.refreshState();
        this.render();

        dataLayer.push({
			'event': 'screen',
			'eventCategory': 'screen page view',
			'eventAction': `/elasticform/${this.id}/screen/${this.screen.id}`,
			'eventLabel': this.screen.id
		});

        switch (this.state) {
            case ElasticForm.STATE_FIRST:
                this.modal.find('.elastic-button-back').hide();
                break;

            case ElasticForm.STATE_PROGRESSION:
                this.modal.find('.elastic-step').show();
                break;

            case ElasticForm.STATE_LAST:
                this.modal.find('.elastic-step').show();
                break;
        }
    }

    /**
     * Renders current form's step (Screen) and tries to
     * initialize map and datetime picker after screen rendering.
     */
    render () {
        let render = this.screen.render();

        this.countProgress();
        this.modal.find('#elastic-body').html(render).end();

        var elasticBody = this.modal.find('#elastic-body');

      
        if (this.show_top_cities) {
            elasticBody.addClass('show-top-cities');
        } else {
            elasticBody.removeClass('show-top-cities');
        }

        this.modal.find('.progress-bar').css('width', `${this.progress}%`);

        this.screen.init();
        try {
            //noinspection ES6ModulesDependencies
            //MapField.init();
        } catch (err) { /* pass */ }
        try {
            //noinspection ES6ModulesDependencies
            // DatetimeField.init();
        } catch (err) { /* pass */ }

        if (this.state === ElasticForm.STATE_LAST) {
            if (this.show_continue_button_at_end) {
                this.modal.find('.elastic-button-next').html('Dalej <img src="/static/project/images/ajax-loader-circle.gif">');
            } else {
                this.modal.find('.elastic-button-next').html('Wyślij <img src="/static/project/images/ajax-loader-circle.gif">');
            }
        } else {
            const screen = this.raw_screens?.[this.index];
            const questions = Array.isArray(screen?.questions) ? screen.questions : [];

            if (this.isOptionalScreen(questions)) {
                const elasticBody = this.modal.find('#elastic-body');
                const button = this.modal.find('.elastic-button-next');

               const updateButtonLabel = () => {
                    const filled = elasticBody.find('input, textarea').toArray()
                        .some(input =>
                            (["checkbox", "radio"].includes(input.type) && input.checked) ||
                            (!["checkbox", "radio"].includes(input.type) && input.value.trim() !== "")
                        );
                    button.text(filled ? "Dalej" : "Pomiń");
                };

                elasticBody.off('input.optional change.optional'); // usuwa stare
                elasticBody.on('input.optional change.optional', 'input, textarea', updateButtonLabel);
                updateButtonLabel();

            } else {
                this.modal.find('.elastic-button-next').html('Dalej');
            }
        }

        this.modal.find('.modal-body.modal-form-body').animate({scrollTop: 0}, "fast");
    }

    /**
     * Sends form data to API endpoint
     */
    submit () {
        $(".elastic-button-next").addClass('ajax-wait');
        if (this.validate()) {
            //noinspection ES6ModulesDependencies
            $.ajax({
                url: reply_endpoint_url,
                type: "POST",
                contentType: "application/json",
                headers: {
                    'X-CSRFToken': configuration.csrf_token || ''
                },
                data: this.serialize()
            }).done(function (response) {
                //noinspection JSUnresolvedVariable
                window.location = response.redirect_url;
            }).fail(function (err) {
                $(".elastic-button-next.ajax-wait").removeClass('ajax-wait');
                //noinspection ES6ModulesDependencies
                elasticModal.modal('hide');
                $('#briefly-content').prepend(`<div class="two-parts-container" style="padding-top:30px;">
                                                    <div class="alert alert-danger text-center alert-dismissible" role="alert">
                                                        <button type="button" class="close" data-dismiss="alert">
                                                           <span aria-hidden="true">&times;</span>
                                                        </button>
                                                        
                                                        <p class="lead"><strong>Ups! coś poszło nie tak.</strong></p>
                                                        Nasi informatycy już wiedzą o tym i naprawiają błąd. Prosimy spróbować później jeszcze raz.
                                                    </div>
                                               </div>`).end();
            });

        }else{
            $(".elastic-button-next.ajax-wait").removeClass('ajax-wait');
        }
        this.dispatch();
    }

    /**
     * Moves index caret to next step (Screen) if possible
     */
    next () {
        if (this.validate()) {
            let newIndex = this.index + 1;
            if (newIndex < this.length) {
                this.index = newIndex;
            }
        }
        this.dispatch();
    }

    /**
     * Moves index caret to prev step (Screen) if possible
     */
    prev () {
        let newIndex = this.index - 1;

        if (newIndex >= 0) {
            this.index = newIndex;
        }
        this.dispatch();
    }

    /**
     * Performs step (Screen) validation
     * @returns {boolean}
     */
    validate () {
        return this.screen.validate();
    }

    /**
     * Performs screen data serialization
     */
    serialize () {
        let reply = {
            formId: this.id,
            current_business: this.current_business,
            questions: [],
        };

        this.screens.forEach((screen) => {
            reply.questions.push(...screen.serialize());
        });

        return JSON.stringify(reply);
    }

    /**
     * Removes events from form's DOM elements,
     * clear states and property values
     */
    destructor () {
        /**
         * Destruct all screens
         */
        this.screens.forEach((screen) => {
            screen.destructor();
        });

        /**
         * Unbind all existing events
         */
        this.modal.off('click', '.elastic-step');
        this.modal.off('submit', '#elastic-form');
        this.modal.off('click check', '.custom_answers input.allow_custom');
        this.modal.off('click check', '.available_answers input[type="radio"]');
        this.modal.off('click focus', 'input[name="custom_answer"]');

        /**
         * Clear critical properties
         */
        this.modal = undefined;
        this.state = undefined;
        this.screens = undefined;
    }

    isOptionalScreen(questions) {
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].optional !== true) {
                return false;
            }
        }
        return true;
    }
}
